import { render, staticRenderFns } from "./DropOffWorkbench.vue?vue&type=template&id=45ff1774&scoped=true&"
import script from "./DropOffWorkbench.vue?vue&type=script&lang=ts&"
export * from "./DropOffWorkbench.vue?vue&type=script&lang=ts&"
import style0 from "./DropOffWorkbench.vue?vue&type=style&index=0&id=45ff1774&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ff1774",
  null
  
)

export default component.exports